<template>
    <v-container fluid>
        <!--    Diálogo Persistente para mostrar Errores    -->
        <v-dialog v-model="dialogErrors" persistent width="400">
            <v-card class="justify-center">
                <v-card-title
                        dark
                        class="red display-1 text--primary justify-center"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text class="text-sm-center">
                    <h3>{{errorsGuard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="dialogErrors = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Lista de Estudiantes     -->
        <v-dialog v-model="dialogDeleteList" max-width="600px">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_list')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogDeleteList = false"
                    >No
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="deleteList()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Lista de Estudiantes    -->
        <v-dialog v-model="dialogListStudents" scrollable max-width="500px">
            <v-card :loading="loading" v-if="Object.keys(dataStudents).length > 0" align="center" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('estudiantes')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogListStudents = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text align="center">
                    <v-layout v-if="dataStudents.code_type === 0" align="center" justify="center" row wrap>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12>
                            <h3>Tutor</h3>
                            <br>
                            <v-layout align-center justify-center row wrap>
                                <v-flex xs11>
                                    <v-img
                                            :src="dataStudents.tutor.idFront"
                                            position="center center"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.available_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_no_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student, i) in dataStudents.available_students" :key="i" :hidden="student.status === -1">
                                    <v-list-item-avatar>
                                        <v-img :src="student.avatar"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{student.first_name}}</v-list-item-title>
                                        <v-list-item-subtitle>{{student.last_name}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-btn
                                            medium
                                            color="success"
                                            @click="allowCheckOut(dataStudents.tutor.id, student.id, dataStudents.qrCode)"
                                    >{{$t('concender_salida')}}
                                    </v-btn>
                                    <v-btn
                                            medium
                                            color="error"
                                            @click="denyCheckOut(dataStudents.tutor.id, student.id, dataStudents.qrCode)"
                                    >{{$t('denegar_salida')}}
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.picked_up_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student2, i) in dataStudents.picked_up_students" :key="i" :hidden="student2.status === -1">
                                    <v-list-item-avatar>
                                        <v-img :src="student2.avatar"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{student2.first_name}}</v-list-item-title>
                                        <v-list-item-subtitle>{{student2.last_name}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="dataStudents.code_type === 1" align="center" justify="center" row wrap>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12>
                            <h3>{{$t('invitado')}}</h3>
                            <br>
                            <v-layout align-center justify-center row wrap>
                                <v-flex xs11>
                                    <v-img
                                            :src="dataStudents.invitation.invited_tutor.idFront"
                                            position="center center"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.available_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_no_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student, i) in dataStudents.available_students" :key="i" :hidden="student.status === -1">
                                    <v-list-item-avatar>
                                        <v-img :src="student.avatar"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{student.first_name}}</v-list-item-title>
                                        <v-list-item-subtitle>{{student.last_name}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-btn
                                            medium
                                            color="success"
                                            @click="allowCheckOut(dataStudents.invitation.invited_tutor.id, student.id, dataStudents.qrCode)"
                                    >{{$t('concender_salida')}}
                                    </v-btn>
                                    <v-btn
                                            medium
                                            color="error"
                                            @click="denyCheckOut(dataStudents.invitation.invited_tutor.id, student.id, dataStudents.qrCode)"
                                    >{{$t('denegar_salida')}}
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                        <v-flex class="text-xs-center pt-3 pb-3 pl-3 pr-3" xs12 v-if="dataStudents.picked_up_students.length > 0">
                            <br>
                            <h3>{{$t('estudiante_s_recogido_s')}}</h3>
                            <br>
                            <v-list two-line>
                                <v-list-item v-for="(student2, i) in dataStudents.picked_up_students" :key="i" :hidden="student2.status === -1">
                                    <v-list-item-avatar>
                                        <v-img :src="student2.avatar"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{student2.first_name}}</v-list-item-title>
                                        <v-list-item-subtitle>{{student2.last_name}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
      </v-dialog>
        <v-col class="text-right">
            {{$t('fullscreen')}}
          <v-btn
              icon
              x-large
              color="primary"
              @click="fullscreen"
          >
            <v-icon>mdi-fullscreen</v-icon>
          </v-btn>
        </v-col>
        <v-layout align-center justify-center fill-height>
          <v-col id="monitor">
            <v-row>
              <v-col cols="4" class="text-center">
                <h2>TURNO ACTUAL</h2>
                <div v-if="studentsList.length !== 0">
                  <v-card v-if="studentsList[0].code_type === 0" class="elevation-2" color="green">
                    <v-card-title class="text-h5">
                      <v-list two-line color="green">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="headline">{{studentsList[0].tutor.first_name}}</v-list-item-title>
                            <v-list-item-subtitle class="headline">{{studentsList[0].tutor.last_name}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar size="150px">
                            <v-img :src="studentsList[0].tutor.avatar"></v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                      </v-list>
                    </v-card-title>
                    <v-card-text>
                        <div v-for="(item, index) in studentsList[0].available_students" v-bind:key="index">
                          <v-list-item v-if="studentsList[0].available_students.length > 0" :hidden="item.status === -1">
                            <v-list-item-avatar size="100px">
                              <v-img :src="item.avatar"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="headline">{{item.first_name}}</v-list-item-title>
                              <v-list-item-subtitle class="headline">{{item.last_name}}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </div>
                    </v-card-text>
                  </v-card>
                  <v-card v-if="studentsList[0].code_type === 1" class="elevation-2" color="green">
                    <v-card-title class="text-h5">
                      <v-list two-line color="green">
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title class="headline">{{studentsList[0].invitation.invited_tutor.first_name}}</v-list-item-title>
                            <v-list-item-subtitle class="headline">{{studentsList[0].invitation.invited_tutor.last_name}}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar size="150px">
                            <v-img :src="studentsList[0].invitation.invited_tutor.avatar"></v-img>
                          </v-list-item-avatar>
                        </v-list-item>
                      </v-list>
                    </v-card-title>
                    <v-card-text>
                      <div v-for="(item, index) in studentsList[0].available_students" v-bind:key="index">
                        <v-list-item v-if="studentsList[0].available_students.length > 0" :hidden="item.status === -1">
                          <v-list-item-avatar size="100px">
                            <v-img :src="item.avatar"></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="headline">{{item.first_name}}</v-list-item-title>
                            <v-list-item-subtitle class="headline">{{item.last_name}}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-if="studentsList.length === 0">
                  <v-alert
                      color="blue"
                      type="info"
                  >{{$t('sin_registros')}}</v-alert>
                </div>
              </v-col>
              <v-col cols="8" class="text-center">
                <h2>PRÓXIMO(S) TURNO(S)</h2>
                <v-timeline v-if="studentsList.length > 1" dense reverse>
                  <v-timeline-item
                      v-for="(data, indexPrincipal) in studentsList"
                      v-bind:key="indexPrincipal"
                      large
                  >
                    <div v-if="studentsList[indexPrincipal].code_type === 0 && indexPrincipal !== 0">
                      <v-card class="elevation-2" color="blue">
                        <v-card-text>
                          <div v-for="(item, index) in studentsList[indexPrincipal].available_students" v-bind:key="index">
                            <v-list-item v-if="studentsList[indexPrincipal].available_students.length > 0" :hidden="item.status === -1">
                              <v-list-item-avatar size="70px">
                                <v-img :src="item.avatar"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title class="subtitle-2">{{item.first_name}}</v-list-item-title>
                                <v-list-item-subtitle class="subtitle-1">{{item.last_name}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                    <div v-if="studentsList[indexPrincipal].code_type === 1 && indexPrincipal !== 0">
                      <v-card class="elevation-2" color="blue">
                        <v-card-text>
                          <div v-for="(item, index) in studentsList[indexPrincipal].available_students" v-bind:key="index">
                            <v-list-item v-if="studentsList[indexPrincipal].available_students.length > 0" :hidden="item.status === -1">
                              <v-list-item-avatar size="70px">
                                <v-img :src="item.avatar"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title class="subtitle-2">{{item.first_name}}</v-list-item-title>
                                <v-list-item-subtitle class="subtitle-1">{{item.last_name}}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-timeline-item>
                </v-timeline>
                <div v-if="studentsList.length === 0 || studentsList.length === 1">
                  <v-alert
                      color="blue"
                      type="info"
                  >{{$t('sin_registros')}}</v-alert>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import { mapState } from 'vuex'


export default {
  name: "monitor",
  data () {
    return {
      colors: [
        'primary',
        'secondary',
        'yellow darken-2',
        'red',
        'orange',
      ],
      model: 0,
      dialogListStudents: false,
      loading: false,
      dataStudents: [],
      dialogDeleteList: false,
      dialogErrors: false,
      errorsGuard: '',
    }
  },
  computed: {
    ...mapState(['studentsList'])
  },

  created () {
    if(localStorage.getItem('listaEstudiantes') !== null) {
      this.studentsList = JSON.parse(localStorage.getItem('listaEstudiantes'))
      console.log(this.studentsList)
    }
  },
  methods: {
    fullscreen () {
      let elem = document.getElementById("monitor")
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      }
    },
    printListStudents(item) {
      this.dataStudents = item
      console.log(this.dataStudents)
      this.dialogListStudents = true
    },
    deleteList () {
      localStorage.removeItem('listaEstudiantes')
      this.studentsList = []
      this.$socket.send(JSON.stringify( {
        "message": JSON.stringify([])
      }))
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_color', 'warning')
      this.$store.commit('snackbar_change_message', this.$t('list_delete_success'))
      this.dialogDeleteList = false
      setTimeout(this.clear, 3000)
    },
    updateDataStudent(qrCode, uuidStudent) {
      let band = false
      let index = -1

      for(let i = 0 ; !band && i < this.studentsList.length; i++) {
        console.log(this.studentsList[i].qrCode, '===', qrCode)
        if(this.studentsList[i].qrCode === qrCode){
          band = true
          index = i
        }
      }
      if (band === true) {
        band = false
        let index2 = -1
        for(let i = 0 ; !band && i < this.studentsList[index].available_students.length; i++) {
          console.log(this.studentsList[index].available_students[i].id, '===', uuidStudent)
          if(this.studentsList[index].available_students[i].id === uuidStudent){
            band = true
            index2 = i
          }
        }
        if(band === true) {
          let alumnoAux = this.studentsList[index].available_students[index2]
          console.log('Ver si realmente se vacia lista alumnos dipsonibles Tam = ', this.studentsList[index].available_students.length)
          // delete this.studentsList[index].available_students[index2]
          this.studentsList[index].available_students.splice(index2, 1)
          console.log('Ver si realmente se vacia lista alumnos dipsonibles Tam = ', this.studentsList[index].available_students.length)

          if (this.studentsList[index].available_students.length === 0) {
            this.studentsList.splice(index, 1)
          } else {
            this.studentsList[index].picked_up_students.push(alumnoAux)
          }
          localStorage.setItem('listaEstudiantes',  JSON.stringify(this.studentsList))
          this.$socket.send(JSON.stringify( {
            "message": JSON.stringify(this.studentsList)
          }))
        }
      }
    },
    allowCheckOut(uuidTutor, uuidStudent, qrCode) {
      this.loading = true
      HTTP.post('exit/validate/' + uuidStudent, {
        idTutor: uuidTutor
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.loading = false
        this.updateDataStudent(qrCode, uuidStudent)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
        setTimeout(this.clear, 3000)
        console.log(response)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 403) {
          this.errorsGuard = this.$t('msg_student_exit_pass_disable')
          this.dialogErrors = true
        }
        console.log(error.response.data)
      })
    },
    denyCheckOut(uuidTutor, uuidStudent, qrCode) {
      this.loading = true
      HTTP.post('exit/invalidate/' + uuidStudent, {
        idTutor: uuidTutor
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.loading = false
        this.updateDataStudent(qrCode, uuidStudent)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
        setTimeout(this.clear, 3000)
        console.log(response)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 403) {
          this.errorsGuard = this.$t('msg_student_exit_pass_disable')
          this.dialogErrors = true
        }
        console.log(error.response.data)
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>
.scroll {
   overflow-y: scroll
}

#monitor:-webkit-full-screen {
  width: 100%;
  height: 100%;
  background: white;
}
</style>
